import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { ImportPicturesFieldEnum } from 'Common/FieldEnum';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { IMPORT_PICTURES_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { renderField } from 'Common/FormHelper';
import { MAX_FILE_SIZE } from './helpers/constants';

const ImportPicturesForm = props => {
  const useServingNumberButtonOptions = [
    { label: 'Student Number', value: false },
    { label: 'Serving Number', value: true },
  ];

  return (
    <Form>
      <TitledCard>
        <Grid>
          <Grid.Row />
          <Grid.Row>
            <Grid.Column>
              <ReduxFormButtonGroup
                label={'How are the pictures named?'}
                formName={IMPORT_PICTURES_FORM_NAME}
                fieldName={ImportPicturesFieldEnum.UseServingNumber}
                options={useServingNumberButtonOptions}
              />
              <Field
                name={ImportPicturesFieldEnum.File}
                label="Choose a .zip file containing pictures of the following types .jpg, .jpeg, or .bmp"
                component={renderField}
                refCallback={props.refCallback}
                type={'file'}
                accept={'.zip'}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>{props.submitFailed && props.error}</Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    </Form>
  );
};

const validate = (values, props) => {
  var errors = {};

  if (
    !values[ImportPicturesFieldEnum.File] ||
    values[ImportPicturesFieldEnum.File].length === 0
  ) {
    errors[ImportPicturesFieldEnum.File] = 'Please choose a file';
  } else if (values[ImportPicturesFieldEnum.File][0].size > MAX_FILE_SIZE) {
    errors[ImportPicturesFieldEnum.File] = 'File size must be less than 1GB.';
  }

  return errors;
};

export default reduxForm({
  destroyOnUnmount: false,
  form: IMPORT_PICTURES_FORM_NAME,
  validate,
  enableReinitialize: true,
})(ImportPicturesForm);



// WEBPACK FOOTER //
// ./src/pages/importpictures/ImportPicturesForm.js